import { postRequest }  from '@/core';
import { orders } from '@/requests';
export default async function(orderIds) {
	let url = orders.getMultipleByIdPath();
	let response = await postRequest(url,{}, { idList: orderIds, searchFilter: {} });
	return response;
}